export default __webpack_public_path__ + "static/Chargam-6a2e41925cd6131b67dc098afccb4c76.png";